const t = {
  name: "Software",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 7C2 4.23772 4.23772 2 7 2H17C19.7623 2 22 4.23772 22 7V17C22 19.7623 19.7623 22 17 22H7C4.23772 22 2 19.7623 2 17V7ZM11 4H7C5.34228 4 4 5.34228 4 7V17C4 18.6577 5.34228 20 7 20H17C18.6577 20 20 18.6577 20 17V7C20 5.34228 18.6577 4 17 4H13V12.5858L16 9.58582L17.4142 11L12 16.4142L6.58579 11L8 9.58582L11 12.5858V4Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Software
};
